import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fmtDate, resolveImage } from "@/lib/api";
import { PageHeader, Card, Empty } from "@/components/ui-bits";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function InventoryProduct() {
  const { pid } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => { api.get(`/inventory/ledger/${pid}`).then(r => setData(r.data)); }, [pid]);
  if (!data) return <div className="text-slate-500 text-sm">Loading…</div>;

  const p = data.product;
  const stock = Number(p.current_stock || 0);
  const min = Number(p.min_stock_threshold || 0);

  return (
    <div data-testid="inventory-product-page">
      <PageHeader
        eyebrow="Stock History"
        title={`${p.product_name} — Inventory Ledger`}
        description={`Unit: ${p.unit} • Current Stock: ${stock.toFixed(2)} • Min: ${min.toFixed(2)}`}
        actions={<Link to="/inventory"><Button variant="outline"><ArrowLeft size={14} className="mr-1"/>Back</Button></Link>}
      />

      <div className="flex items-center gap-4 mb-4">
        {p.image_url ? (
          <img src={resolveImage(p.image_url)} alt="" className="w-20 h-20 rounded-md object-cover border border-slate-200"/>
        ) : (
          <div className="w-20 h-20 rounded-md border border-dashed border-slate-300 bg-slate-50"/>
        )}
        <div>
          <div className="font-heading font-semibold text-lg">{p.product_name}</div>
          <div className="text-sm text-slate-500">{p.description}</div>
        </div>
      </div>

      <Card padding="p-0">
        {data.transactions.length === 0 ? <div className="p-8"><Empty title="No movements yet"/></div> : (
          <div className="overflow-x-auto">
            <table className="ddms-table">
              <thead><tr><th>Date</th><th>Type</th><th>Reference</th><th className="num">In</th><th className="num">Out</th><th className="num">Balance</th><th>Remarks</th></tr></thead>
              <tbody>
                {data.transactions.map(t => (
                  <tr key={t.id}>
                    <td className="font-mono text-xs">{fmtDate(t.transaction_date)}</td>
                    <td><span className="px-2 py-0.5 rounded-full text-[11px] bg-cobalt-50 text-cobalt-700 font-medium">{t.transaction_type}</span></td>
                    <td className="font-mono text-xs">{t.reference_no}</td>
                    <td className="num text-emerald-600 font-mono">{t.in_qty > 0 ? Number(t.in_qty).toFixed(2) : "—"}</td>
                    <td className="num text-rose-600 font-mono">{t.out_qty > 0 ? Number(t.out_qty).toFixed(2) : "—"}</td>
                    <td className="num font-semibold font-mono">{Number(t.balance_qty).toFixed(2)}</td>
                    <td className="text-slate-500">{t.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
